var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',[_c('v-btn',{attrs:{"black":"","dense":""},on:{"click":_vm.generarDocumento}},[_vm._v(" generar Archivos ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }